import { Button } from "../../Atoms/Button";
import { AsyncSimpleSelect } from "../../Atoms/Selects/AsyncSelect";
import { Title } from "../../Atoms/Title";
import * as S from "./styles";
import { useDispatcherCustomer } from "./useDispatcherCustomer";

export const DispatcherCustomerTemplate = () => {
  const {
    navigate,
    Controller,
    control,
    handleSubmit,
    submitForm,
    getValues,
    uuidAgendamento,
  } = useDispatcherCustomer();

  return (
    <S.Container>
      <S.Wrapper>
        <Title>Cliente Referente ao Agendamento</Title>

        <S.FormDespachanteCliente onSubmit={handleSubmit(submitForm)}>
          <div>
            <Controller
              name="uuid"
              control={control}
              render={({ field: { onChange } }) => (
                <AsyncSimpleSelect
                  variant="search"
                  placeholder=""
                  isClearable
                  required
                  noOptionsMessage={() => (
                    <S.NotFoundvalue>
                      Não encontrado
                      <img
                        src={"/assets/svgs/icon-plus-round-gray.svg"}
                        alt={"icone de adicionar"}
                        onClick={() =>
                          navigate(
                            `/agendamento/${uuidAgendamento}/despachante-cliente/cadastro-cliente`
                          )
                        }
                      />
                    </S.NotFoundvalue>
                  )}
                  onChange={(e) => (e ? onChange(e?.value) : onChange(""))}
                  loadOptions={getValues}
                />
              )}
            />
          </div>
          <div>
            <Button>Selecionar</Button>
          </div>
        </S.FormDespachanteCliente>

        <Button data-variant-text onClick={() => navigate(-1)}>
          Voltar
        </Button>
      </S.Wrapper>
    </S.Container>
  );
};
